import React from "react";

import { Box, Icon, Typography } from "@bca/ui-library";

interface ITransportAlert {
  message: string;
  weight?: string;
  mt?: number;
  mb?: number;
}

const TransportAlert: React.FunctionComponent<ITransportAlert> = ({
  message,
  weight = "normal",
  mt = 0,
  mb = 0,
}) => {
  return (
    <Box
      as="section"
      display="flex"
      alignItems="flex-start"
      justifyContent="flex-start"
      mt={mt}
      mb={mb}
    >
      <Box as="section" flexShrink={0}>
        <Icon
          name="triangle-exclamation"
          color="secondary-orange"
          weight="solid"
          width={18}
          height={18}
        />
      </Box>

      <Typography m={0} ml={2} variant="body" fontWeight={weight}>
        {message}
      </Typography>
    </Box>
  );
};

export default TransportAlert;
